<template>
  <div class="loading--container">
    <div class="spinner-container">
      <div class="spinner" :class="{'success': typeof success === 'boolean'}"></div>
      <check-icon v-if="success" class="logo" size="36" color="#36A3CA" />
      <x-icon v-if="success === false" class="logo" size="36" color="#DC2626" />
    </div>
    <p class="loading--message" v-if="loadingMessage">
      {{ afterLoadingMessage || loadingMessage }}
    </p>
  </div>
</template>

<script>
import { CheckIcon, XIcon } from '@vue-hero-icons/solid';

export default {
  name: 'onboarding-loading',
  data: () => ({
    success: null,
    afterLoadingMessage: null,
  }),
  props: {
    loadingMessage: {
      type: String,
    },
  },
  methods: {
    stopLoading({ success, timeout, message }) {
      return new Promise((resolve) => {
        this.success = success;
        this.afterLoadingMessage = message;
        return setTimeout(() => resolve(true), timeout);
      });
    },
  },
  components: {
    CheckIcon,
    XIcon,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .loading--container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background-color: rgba(15, 23, 42, 0.5);
    width: 100%;
    height: 100%;
  }

  .spinner-container {
    position: relative;
    width: 64px;
    height: 64px;
  }

  .loading--message {
    font-family: 'Usual';
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: $white;
  }

  .logo {
    display: inline-block;
    text-align: center;
    position: absolute;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
  }

  .spinner {
    position: relative;
    width: 64px;
    height: 64px;
    background-color: transparent;
    border-radius: 50%;
    border: 4px solid rgba(255,255,255,0.3);
    border-left-color: $white;
    animation: spin 1s linear infinite;

    &.success {
      background-color: $white;
    }
  }

  @keyframes spin {
    to { transform: rotate(360deg)}
  }
</style>
